// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"71ed0f70","71":"f50a60a7","165":"6979f55a","185":"fed8e3f9","220":"79628f3e","287":"32edf832","333":"22d3f638","361":"ac7d26da","440":"35f25287","453":"841ad29a","481":"329a2534","692":"abcdfde5","926":"3fe18940","967":"77ff05dd","972":"782b2cd5"}[chunkId] + ".chunk.js";
};